import { withRBAC } from "../../rbac";
import { HolidayCreate } from "./Create";
import { HolidayEdit } from "./Edit";
import { HolidayList } from "./List";

export const holidays = {
  list: withRBAC(HolidayList, "view_hr"),
  create: withRBAC(HolidayCreate, "manage_hr"),
  edit: withRBAC(HolidayEdit, "manage_hr"),
  recordRepresentation: "name",
};
